// Import Packages
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Import Material UI
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from "@material-ui/icons/Create";

// Import Pages
import { libraryIcons } from '../../autom/NewFlowLibraryAssetManager';
import AddNewVariables from "../../autom/leftSideBar/variables/addNewVariables/AddNewVariables";
import EditVariables from '../../autom/leftSideBar/variables/editVariables/EditVariables';
import ModuleItem from './ModuleItem/ModuleItem';
import LibraryItem from './LibraryItem/LibraryItem';

// Import Services
import LibraryService from '../../../../../services/LibraryService/LibraryService';
import VariableService from '../../../../../services/VariableService/VariableService';

// Import Icons
import VariableIcon from '../../../../../assets/icons/moduleIcons/variables-icon.svg';
import ApplicationIcon from '../../../../../assets/icons/moduleIcons/applications-icon.svg';
import AIicon from '../../../../../assets/icons/moduleIcons/ai-actions-icon.svg';
import UIicon from '../../../../../assets/icons/moduleIcons/ui-actions-icon.svg';
import AdvancedActionIcon from '../../../../../assets/icons/moduleIcons/advanced-actions-icon.svg';
import SearchIcon from '../../../../../assets/icons/search-icon.svg';

// Import CSS
import './LeftArea.css';

const defaultLibraryImg = `default_library.png`

const LeftArea = ({
    automType,
    handleDragEnd,
    handleDragStart,
    variables,
    setVariables,
    openVariable,
    setOpenVariable,
    automVersionId
}) => {
    const { t } = useTranslation();
    const [categories, setCategories] = useState([]);
    const [variableSearch, setVariableSearch] = useState("");
    const [moduleSearch, setModuleSearch] = useState({});
    const [variableType, setVariableType] = useState([]);
    const [getByVariables, setGetByVariables] = useState([]);
    const label = "CONTENT.FLOW.LEFT-AREA.";

    useEffect(() => {
        //get all library dataasdsad
        async function fetchData() {
            const response = await LibraryService.getAllLibrary();
            if (response) {
                if (response?.status) {
                    let categoriesData = response.data;
                    categoriesData.forEach(category => {
                        category.expand = false;
                        category.libraries.forEach(library => {
                            library.expand = false;
                            library.visible = true;

                            library.library_versions.find(item => item.is_active).actions.forEach(action => action.visible = true)
                            //library.actions.forEach(action => action.visible = true)
                        })
                    });
                    setCategories(categoriesData);
                }
            }
        }

        fetchData().then(r => r);

        async function fetchVariableType() {
            let { data } = await VariableService.getVariableType();
            if (Array.isArray(data)) {
                if (automType === "Autom") {
                    data = data.filter(function (obj) {
                        return obj.name !== "app connector";
                    });
                }
                setVariableType(data)
            }
        }

        fetchVariableType().then(r => r);
    }, []);

    const handleEditVariable = async (id, variable) => {
        if (!variable?.system_variable) {
            const { data } = await VariableService.getByVariable(id);
            if (typeof data === "object") {
                setGetByVariables(data);
            }
            setOpenVariable({ type: "edit", id: id })
        } else {
            // setGetByVariables(variable);
            // setOpenVariable({type: "edit", id: id})
        }
    }

    const filterBySearch = (searchTextOrj, i) => {
        let copySearch = { ...moduleSearch };
        copySearch[i] = searchTextOrj;
        setModuleSearch(copySearch);
        let copyCategories = [...categories];
        let category = copyCategories[i];
        let searchText = searchTextOrj.toLowerCase();

        category.libraries.forEach(library => {
            if (library.library_versions[library.library_versions.length - 1].actions) {
                if (searchText === "") {
                    library.expand = false;
                    library.visible = true;
                    library.library_versions[library.library_versions.length - 1].actions.forEach(action => action.visible = true)
                } else if (t("CONTENT.LIBRARY." + library.library_name + ".NAME")
                    .toLowerCase().includes(searchText)) {
                    library.expand = true;
                    library.visible = true;
                    library.library_versions[library.library_versions.length - 1].actions.forEach(action => action.visible = true)
                } else {
                    library.expand = false;
                    library.visible = false;
                    library.library_versions[library.library_versions.length - 1].actions.forEach(action => {
                        if (t(`CONTENT.LIBRARY.${library.library_name}.ACTION.${action.action_name}`).toLowerCase().includes(searchText)) {
                            library.expand = true;
                            library.visible = true;
                            action.visible = true;
                        } else action.visible = false;
                    })
                }
            }
        })
        copyCategories[i] = category;
        setCategories([...copyCategories])
    }

    const getIconByModuleName = (module_name) => {
        switch (module_name) {
            case 'APPS':
                return ApplicationIcon;
                break;
            case 'ADVANCED-ACTIONS':
                return AdvancedActionIcon;
                break;
            case 'AI-ACTIONS':
                return AIicon;
                break;
            case 'UI-ACTIONS':
                return UIicon
                break;
            default:
                break;
        }
    }

    return (
        <div>
            {/* variable module start */}
            <ModuleItem icon={VariableIcon} title={t(label + "VARIABLES")} description={t(label + "VARIABLE-DESC")}
                count={variables ? variables.length : 0} learnMoreLink={"#"} >

                {/* search section */}
                <div className="variable-search-container m-b-14">
                    <div className="module-item-search variable-search-input">
                        <input value={variableSearch} className="module-item-search-text variable-module-search-text" placeholder={t(label + "SEARCH")}
                            onChange={(e) => setVariableSearch(e.target.value)} />
                    </div>
                    <div className='new-variable-section' onClick={() => setOpenVariable({ type: "open", id: "" })} >
                        <AddIcon className="new-variable-icon" />
                        <div>{t(label + "ADD-NEW")}</div>
                    </div>
                </div>

                {/* variable list section */}
                {
                    variables?.filter(variable => {
                        if (variableSearch === '') {
                            return variable;
                        } else if (variable.name.toLowerCase().includes(variableSearch.toLowerCase())) {
                            return variable
                        }
                    }).map(variable =>
                        <div className="variable-item-container" >
                            <div>
                                <strong>[{variable.type}]</strong>
                                <label className="variable-label">{variable.name}</label>
                            </div>

                            {
                                variable.name !== "triggerParam" && !variable.system_variable && !variable.related_item_id &&
                                <CreateIcon className="variable-edit-icon"
                                    onClick={() => handleEditVariable(variable.id, variable)} />
                            }
                        </div>
                    )
                }

            </ModuleItem>
            {/* variable module end */}

            {
                categories &&
                categories.map((category, index) => (
                    <div key={category.id}>
                        <ModuleItem icon={getIconByModuleName(category.module_name)} title={t("CONTENT.AUTOMS-LIST." + category.module_name)} description={t(label + category.module_name + "-DESC")}
                            count={category.libraries ? category.libraries.length : 0} learnMoreLink={"#"} >
                            <div className="module-item-search m-b-14">
                                <img className="module-item-search-icon" src={SearchIcon} alt="" />
                                {/* <SearchIcon className="module-item-search-icon" /> */}
                                <input value={moduleSearch[index] ? moduleSearch[index] : ''} className="module-item-search-text module-search-text" placeholder="Search"
                                    onChange={(e) => filterBySearch(e.target.value, index)} />
                            </div>
                            {category.libraries &&
                                category.libraries.map((library, indexLib) => (
                                    library.visible &&
                                    <LibraryItem
                                        img={library.image?.includes('data:') ? library.image :
                                            require(`../../../../../../public/images/libraries/${(library.is_system ? "system" : "custom")}/${library.image ? library.image : defaultLibraryImg}`)}
                                        name={library.library_label.includes('CUSTOM') ? library.library_name :
                                            t("CONTENT.LIBRARY." + library.library_name + ".NAME")}
                                        actions={library.library_versions[library.library_versions.length - 1].actions
                                            ?
                                            library.library_versions[library.library_versions.length - 1].actions :
                                            []
                                        }
                                        library={library}
                                        handleDragStart={handleDragStart}
                                        handleDragEnd={handleDragEnd}
                                    />
                                ))
                            }

                        </ModuleItem>
                    </div>
                ))
            }
            {(openVariable?.type === "open" || openVariable === true) &&
                <AddNewVariables setOpen={setOpenVariable} variableType={variableType} variables={variables}
                    setVariables={setVariables} automVersionId={automVersionId} />}
            {openVariable?.type === "edit" &&
                <EditVariables setOpenVariables={setOpenVariable} variableTypeList={variableType}
                    setVariables={setVariables} getByVariables={getByVariables} />}
        </div>
    )
}
export default LeftArea;
